module.exports = __webpack_public_path__ + "static/img/20.ac7ea6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/20.png
// module id = XFKS
// module chunks = 1